import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationBlockValueAdjustmentsConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationBlockValueAdjustments";
    static FUNCTION_DELETE_MULTIPLE_PROPERTY_VALUATION_BLOCK_VALUE_ADJUSTMENTS = "DeleteMultipleValuationBlockValueAdjustments";
    static FUNCTION_UPLOAD_VALUATION_BLOCK_VALUE_ADJUSTMENT = "UploadValuationBlockValueAdjustments";
}
